export default "__VITE_ASSET__CbZE6dbu__"